<div appearance="outlined" class="coll-themed-class container-height full-width no-shadow no-background">
    <div id="dicom-patient-details">
        <form [formGroup]="patientDataForm" class="custom-col-class col-sm-6 form" >
            <h3>{{'ToolUploadRegistryPatient' | translate}}</h3>
            <div class="coll-themed-class border-1-solid margin-bottom-7-important flex-input-container">
                <div>
                    <mat-form-field appearance="outline" class="se-form-field form-input-field" [hideRequiredMarker]="true">
                        <mat-label [ngClass]="{'label-color' : isDisabled('issuer')}">{{'Issuer' | translate}}</mat-label>
                        <input matInput id="issuer" formControlName="issuer">
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field appearance="outline" class="se-form-field form-input-field" [hideRequiredMarker]="true">
                        <mat-label [ngClass]="{'label-color' : isDisabled('patientId')}">{{'PatientIdentifier' | translate}}</mat-label>
                        <input matInput id="patientId" formControlName="patientId" [placeholder]="'PatientIdentifier' | translate">
                    </mat-form-field>
                </div>

                <div>
                    <mat-form-field appearance="outline" class="se-form-field form-input-field" [hideRequiredMarker]="true">
                        <mat-label [ngClass]="{'label-color' : isDisabled('name')}">{{'FirstName' | translate}}</mat-label>
                        <input matInput id="name" formControlName="name" [placeholder]="'FirstName' | translate">
                    </mat-form-field>
                </div>

                <div>
                    <mat-form-field appearance="outline" class="se-form-field form-input-field" [hideRequiredMarker]="true">
                        <mat-label [ngClass]="{'label-color' : isDisabled('surname')}">{{'LastName' | translate}}</mat-label>
                        <input matInput id="surname" formControlName="surname" [placeholder]="'LastName' | translate">
                    </mat-form-field>
                </div>

                <div>
                    <mat-form-field appearance="outline" class="se-form-field form-input-field" [hideRequiredMarker]="true">
                        <mat-label [ngClass]="{'label-color' : isDisabled('sex')}">{{'Sex' | translate}}</mat-label>
                        <input matInput id="sex" formControlName="sex" [placeholder]="'Sex' | translate">
                    </mat-form-field>
                </div>

                <div>
                    <mat-form-field appearance="outline" class="se-form-field form-input-field" [hideRequiredMarker]="true">
                        <mat-label [ngClass]="{'label-color' : isDisabled('birthDate')}">{{'BirthDate' | translate}}</mat-label>
                        <input matInput formControlName="birthDate" [matDatepicker]="picker">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker typeof="date"></mat-datepicker>
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field appearance="outline" class="se-form-field form-input-field" [hideRequiredMarker]="true">
                        <mat-label [ngClass]="{'label-color' : isDisabled('accessionNumber')}">{{'Accession_Number' | translate}}</mat-label>
                        <input matInput id="accessionNumber" formControlName="accessionNumber" [placeholder]="'AccessionNumber' | translate">
                    </mat-form-field>
                </div>
                <div *ngIf="isVNA">
                    <mat-form-field appearance="outline" class="se-form-field form-input-field" [hideRequiredMarker]="true">
                        <mat-label [ngClass]="{'label-color' : isDisabled('businessUnit')}">{{'OrderBusinessUnit' | translate}}</mat-label>
                        <div>
                            <mat-select id="businessUnit" formControlName="businessUnit">
                                <mat-option *ngFor="let option of options" [value]="option">{{option.description}}</mat-option>
                            </mat-select>
                        </div>
                    </mat-form-field>
                </div>
            </div>
</form>
</div>
</div>
